import _ from "lodash";

export default {
  data() {
    return {
      pageLoader: null
    };
  },
  methods: {
    showPageLoader() {
      this.pageLoader = this.$loading({ target: "#main-content" });
    },
    hidePageLoader() {
      if (!this.pageLoader) {
        return;
      }
      this.pageLoader.close();
    },
    wrapLoadAction(method) {
      this.showPageLoader();
      return payload =>
        method(payload)
          .then(data => {
            this.hidePageLoader();
            return data;
          })
          .catch(err => {
            const respStatus = _.get(err, "response.status");
            if (respStatus && respStatus !== 403) {
              this.$notify({
                title: "Error",
                message:
                  "Oops, there was a problem fetching the data. Please try again.",
                type: "error"
              });
            }
            this.hidePageLoader();
            throw err;
          });
    },
    wrapApiAction(method, { resourceName = "Changes" } = {}) {
      this.showPageLoader();
      return payload =>
        method(payload)
          .then(data => {
            this.hidePageLoader();
            this.$notify({
              title: "Success",
              message: `${resourceName} successfully saved`,
              type: "success"
            });
            return data;
          })
          .catch(err => {
            this.hidePageLoader();
            this.$notify({
              title: "Error",
              message: "Oops, something went wrong",
              type: "error"
            });
            throw err;
          });
    }
  }
};
